import { Controller, useForm } from "react-hook-form";
import AdminCompanyMappingModel from "../../../models/admin/dashboard/response/AdminCompanyMappingModel";
import AdminUserCompanyMappingRequestModel from "../../../models/admin/dashboard/request/AdminUserCompanyMappingRequestModel";
import IdNameModel from "../../../models/common/IdNameModel";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { FORM_SELECT_RULE } from "../../../utils/validation-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";

interface AdminUserProps {
    mappingList: AdminCompanyMappingModel[];
    adminId: string;
    companyList: IdNameModel[];
    onCloseMapping: () => void;
    onMappingSave: (objMapping: AdminUserCompanyMappingRequestModel) => void;
}

const AdminCompanyMappingComponent = (props: AdminUserProps) => {
    const {
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<AdminUserCompanyMappingRequestModel>({
        mode: "onChange"
    });

    const onSubmit = (formData: AdminUserCompanyMappingRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.adminId = props.adminId;
        formData.userId = GuidEnum.Empty;
        props.onMappingSave(formData);
    }

    const columnsMapping = [
        { key: "AdminName", text: "Admin Name", sort: false, searchable: false },
        { key: "CompanyName", text: "Company Name", sort: false, searchable: false }
    ];

    return (
        <>
            <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-md-6">
                        <Controller name="companyId" control={control} defaultValue={GuidEnum.Empty} rules={FORM_SELECT_RULE}
                            render={({ field }) => (
                                <Autocomplete {...field} value={props.companyList.find(x => x.guId === field.value) || null}
                                    onChange={(_, newValue) => field.onChange(newValue ? newValue.guId : GuidEnum.Empty)} options={props.companyList} getOptionLabel={(option) => option.name || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Company" size="small" required margin="normal" fullWidth error={!!errors.companyId} helperText={errors.companyId?.message} />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                />
                            )}
                        />
                    </div>
                    <div className="col-md-3">
                        <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                            Save
                        </Button>
                    </div>
                </div>
            </form>
            <div className="row">
                <div className="col-md-12">
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columnsMapping.map((column: any) => (
                                        <TableCell key={column.key} className="table-header-cell">
                                            <span>{column.text}</span>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.mappingList.map((row: AdminCompanyMappingModel, index) => (
                                    <TableRow>
                                        <TableCell>{row.adminName}</TableCell>
                                        <TableCell>{row.companyName}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    );
};
export default AdminCompanyMappingComponent;